import { FC, RefObject, useEffect, useRef, useState } from 'react';

import { STICKY_SUMMARY_HEIGHT_CSS_VARIABLE } from '@telialt/core-eshop/src/CartSummaryBox/constants';
import { StickySummary } from '@telialt/core-eshop/src/StickySummary/StickySummary';
import { BaseProduct } from '@telialt/models/src/EshopModel';

type Props = {
    topPriceRef: RefObject<HTMLElement>;
    cartTotalsRef: RefObject<HTMLElement>;
    baseProduct: BaseProduct;
};

export const ProductStickySummary: FC<Props> = ({ topPriceRef, cartTotalsRef, baseProduct }) => {
    const [isStickyMenuVisible, setIsStickyMenuVisible] = useState<boolean>(true);

    const stickySummaryRef = useRef<HTMLElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            const cartMenuFooterRect = cartTotalsRef.current?.getBoundingClientRect();
            const topPriceRect = topPriceRef.current?.getBoundingClientRect();

            const hasScrolledPastTopPrice = topPriceRect ? topPriceRect.bottom < 0 : false;
            const hasCartFooterReachedTop = cartMenuFooterRect ? cartMenuFooterRect.top <= 0 : false;

            setIsStickyMenuVisible(hasScrolledPastTopPrice && !hasCartFooterReachedTop);
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [topPriceRef, cartTotalsRef]);

    useEffect(() => {
        const height = stickySummaryRef.current?.getBoundingClientRect()?.height || 0;

        document.documentElement.style.setProperty(
            STICKY_SUMMARY_HEIGHT_CSS_VARIABLE,
            `${isStickyMenuVisible ? height : 0}px`,
        );

        return () => {
            document.documentElement.style.removeProperty(STICKY_SUMMARY_HEIGHT_CSS_VARIABLE);
        };
    }, [isStickyMenuVisible]);

    return <StickySummary isVisible={isStickyMenuVisible} ref={stickySummaryRef} baseProductName={baseProduct?.name} />;
};
